import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getStatisticAreaList(params) {
  return request({
    url: URL.mdm.basicData.statisticArea,
    method: 'get',
    params
  })
}

export function saveStatisticArea(data) {
  return request({
    url: URL.mdm.basicData.statisticArea,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delStatisticArea(uuid) {
  return request({
    url: URL.mdm.basicData.statisticArea + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
